import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import Spacer from '../../../components/spacer'
import Select from '../../select'
import SelectItem from '../../../components/select-item'
import SelectShapes from '../../../components/select-shapes'
import MultiStoneShapes from '../../select-shapes/multi_stone_shapes'
import MultiStoneHaloPanel from './multi-stone-halo-panel'
import {showMultiStonePanel} from '../../../utils/jewelry-validation'

class MultiStonePanel extends Component {
  render () {
    const props = this.props
    const getMultiStoneQualityOptions = () => {
      let options = [
        {value: 'standard', label: 'Standard'},
        {value: 'plus', label: 'Plus'},
        {value: 'lab_grown', label: 'Lab Grown'}
      ]

      return options
    }
    return (
      <JewelryPanel
        id='multiStoneAndSideStoneHaloPanel'
        show={showMultiStonePanel(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          label='Multi-Stone Ring?'
          labelId='multistone'
          options={[
            {value: false, label: 'No'},
            {value: true, label: 'Yes'}
          ]}
          value={props.multi_stone_ring}
          onChange={props.onChangeVal.bind(this, 'multi_stone_ring')}
          initVal={null}
        />

        <JewelryPanel
          id='multiStonePanel'
          show={props.multi_stone_ring}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            id='multi_stone_setting'
            label='Multi-Stone Type'
            labelId='multi_stone_setting'
            options={[
              {value: 'three_stone', label: 'Three Stone'},
              {value: 'five_stone', label: 'Five Stone'},
              {value: 'seven_stone', label: 'Seven Stone'}
            ]}
            value={props.multi_stone_setting}
            onChange={props.onChangeVal.bind(this, 'multi_stone_setting')}
            initVal={null}
          />

          <Spacer xxs />

          <h4>Multi-Stone Shape</h4>

          <SelectShapes
            id='multi_stone_shape'
            single
            listFor={'multi_stone'}
            value={props.multi_stone_shape}
            onChange={props.onChangeMultiStoneShapeOrQuality.bind(this, 'multi_stone_shape')}
            shapes={MultiStoneShapes}
            initVal={[]}
          />

          <Spacer xxxs />

          <SelectItem
            label='Multi-Stone Quality'
            id='multiStoneQuality'
            labelId='multi_stone_quality'
            options={getMultiStoneQualityOptions()}
            value={props.multi_stone_quality}
            onChange={props.onChangeMultiStoneShapeOrQuality.bind(this, 'multi_stone_quality')}
            initVal={null}
          />

          <Spacer xxs />

          <h4>Multi-Stone Size (mm)</h4>
          <Select
            id='multi_stone_size'
            multi={false}
            options={props.multiStoneSizeOption}
            value={props.small_diamond_id}
            onChange={props.onChangeVal.bind(this, 'small_diamond_id')}
            matchPos='start'
            matchProp='label'
            disabled={!(props.multi_stone_shape && props.multi_stone_shape.length && props.multi_stone_quality)}
          />

          <MultiStoneHaloPanel {...props}
            onChange={props.onChangeVal}
            defaultHaloWidthOptions={props.defaultHaloWidthOptions}
          />

        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

export default MultiStonePanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/multi-stone-panel/index.js